/**
 * Консоль
 * @param type
 * @param arr
 * @returns {boolean}
 * @constructor
 */
function VGLog(type, arr = []) {
	if (!type) return false;

	switch (type) {
		case 'error':
			arr.forEach(function (item) {
				console.error(item);
			});
			break;
		case 'debug':
			arr.forEach(function (item) {
				console.debug(item);
			});
			break;
		case 'success':
			if (arr.length) {
				arr.forEach(function (item) {
					console.log("%c" + item, "color: green;");
				});
			}
			break;
		default:
			console.log(type);
			break;
	}
}

export {VGLog};
